module.exports = __webpack_public_path__ + "img/add-folder-hover.2574b314.svg";